module.exports = __webpack_public_path__ + "img/2.ec21520c.png";